import { Component, OnInit } from '@angular/core';
import { LoginService } from './shared/services/login.service';
import { bodyBusquedaTicket, bodyCodificado, ConfigInitial } from './shared/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { distinctUntilChanged, filter } from 'rxjs';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { RegexService } from './shared/services/regex.service';
import * as CryptoJs from 'crypto-js';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public configInitial!: ConfigInitial;
  public anioActual: number = new Date().getFullYear();
  public loadingConfig: boolean = false;
  public searchingTicket: boolean = false;
  public primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--bs-themecolor').trim();
  public generalFont = getComputedStyle(document.documentElement).getPropertyValue('--custom-font-family').trim();
  public formTicket: FormGroup;
  public patternRFCValue: RegExp = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
  public parametro: string | null = null;
  public isMantenimiento: boolean = false;

  constructor(
    private loginService: LoginService,
    private http: HttpClient,
    private modalService: NzModalService,
    private notificationSubmit: NzNotificationService,
    private regexService: RegexService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.formTicket = new FormGroup({
      rfcReceptor: new FormControl('', [
        Validators.pattern(this.patternRFCValue)
      ]),
      referencia: new FormControl('', [
        Validators.required
      ]),
      montoTotal: new FormControl(null, [
        Validators.required
      ]),
      rfcEmisor: new FormControl()
    });
  }

  ngOnInit(): void {
    this.getConfigInitial();
  }

  public getConfigInitial(): void {
    this.loadingConfig = true;

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd), // Solo cuando la navegación ha terminado
        distinctUntilChanged() // Evitar valores repetidos
      )
      .subscribe(() => {
        const currentRoute = this.activatedRoute.root.firstChild;
        if (currentRoute) {
          currentRoute.paramMap.subscribe(params => {
            this.parametro = params.get('id');
            if (this.parametro) {
              this.loginService.getConfiguration(this.parametro).subscribe(
                response => {
                  localStorage.setItem("configInicial", JSON.stringify(response));
                  this.configInitial = response;
                  this.changePrimaryColor(this.configInitial.color);
                  this.changeGeneralFont(`${this.configInitial.fuente}, sans-serif`);
                  this.formTicket.controls['rfcEmisor'].setValue(this.configInitial.rfcEmisor);
                  this.loadingConfig = false;
                }
              )
            } else {
              this.loginService.getConfiguration(window.location.hostname).subscribe(
                response => {
                  localStorage.setItem("configInicial", JSON.stringify(response));
                  this.configInitial = response;
                  this.changePrimaryColor(this.configInitial.color);
                  this.changeGeneralFont(`${this.configInitial.fuente}, sans-serif`);
                  this.formTicket.controls['rfcEmisor'].setValue(this.configInitial.rfcEmisor);
                  this.loadingConfig = false;
                }
              )
            }
          });
        }
      });
  }

  public sendLogin(): void {
    this.formTicket.markAllAsTouched();
    const montoInicial = parseFloat(this.formTicket.get('montoTotal')?.value);

    if (this.formTicket.valid === true) {
      this.searchingTicket = true;

      const formData: bodyBusquedaTicket = {
        montoTotal: montoInicial,
        referencia: this.formTicket.value['referencia'],
        rfcReceptor: this.formTicket.value['rfcReceptor'],
        rfcEmisor: this.formTicket.value['rfcEmisor']
      };

      this.loginService.buscarConfiguracionTicket(formData).subscribe(
        response => {
          const responseIDConfig: string = response;
          const bodyCodificado: bodyCodificado = {
            datosTicket: formData,
            urlAutoportal: window.location.href,
            loader: {
              speed: this.configInitial.loader.speed,
              src: this.configInitial.loader.src
            }
          };

          const bodyEncriptado: string = CryptoJs.AES.encrypt(JSON.stringify(bodyCodificado), environment.key_enc_url).toString();
          this.searchingTicket = false;
          window.location.href = `${this.configInitial.url_redireccion}/home?configuration=${responseIDConfig}&dataAutoportal=${encodeURIComponent(bodyEncriptado)}`;
        }, (errorBusqueda: any) => {
          this.searchingTicket = false;
          switch (errorBusqueda.status) {
            case 404:
              this.loginService.getMensajePersonalizado(this.configInitial.rfcEmisor, 'TICKET_404').subscribe(
                responsePersonalizado => {
                  this.modalService.error({
                    nzTitle: responsePersonalizado.header,
                    nzContent: `<p>${responsePersonalizado.content}</p> <p>${responsePersonalizado.footer}</p>`,
                    nzCentered: true
                  });
                }, (error: any) => {                  
                  this.modalService.error({
                    nzTitle: '¡Error!',
                    nzContent: JSON.parse(errorBusqueda.error).detail,
                    nzCentered: true
                  });
                }
              )
              break;
            default:
              this.modalService.error({
                nzTitle: '¡Error!',
                nzContent: JSON.parse(errorBusqueda.error).detail,
                nzCentered: true
              });
              break;
          }
        }
      )
    } else {
      this.notificationSubmit.error('¡Alerta!', 'Completa los campos correctamente para continuar.');
    };
  };

  public changePrimaryColor(color: string): void {
    document.documentElement.style.setProperty('--bs-themecolor', color);
    this.primaryColor = color; // Actualiza la propiedad para mostrar el color actual
  }

  public changeGeneralFont(font: string): void {
    document.documentElement.style.setProperty('--custom-font-family', font);
    this.generalFont = font; // Actualiza la propiedad para mostrar la fuente actual
  }


  public REFERENCIA_ON_PASTE(event: ClipboardEvent) {
    return this.regexService.REFERENCIA_PASTE_REMOVE_SPACES_START_MIDDLE_END(event, this.formTicket);
  };

  public removeSpaces(event: KeyboardEvent) {
    return this.regexService.allExceptSpaces(event);
  };

  public RFC_ON_PASTE(event: ClipboardEvent) {
    return this.regexService.RFC_PASTE_JUST_AMPERSAND_LETTERS_NUMBERS(event, this.formTicket)
  };

  public omit_special_char(event: KeyboardEvent) {
    return this.regexService.omit_special_characters_except_AMPERSAND(event);
  };

  public isExtranjero(event: any) {
    if (event.target.checked) {
      this.formTicket.controls['rfcReceptor'].setValue('XEXX010101000');
    } else {
      this.formTicket.controls['rfcReceptor'].setValue('');
    }
  }

}
